// tslint:disable-next-line:variable-name
export const AttributeMetadata = Symbol('AttributeMetadata') as any;
